import ArrowRight from '../src/ArrowRight';
export default ArrowRight;
